// src/components/ProgressBar.ts
export class ProgressBar {
    constructor(totalSteps, currentStep) {
        this.totalSteps = totalSteps;
        this.currentStep = currentStep;
    }
    render() {
        const percentage = (this.currentStep / this.totalSteps) * 100;
        return `
            <div class="progress-bar-container" title="Onboarding Progress: Step ${this.currentStep} of ${this.totalSteps}">
                <div class="progress-bar" style="width: ${percentage}%;"></div>
            </div>
        `;
    }
}
